// REA-CI/screens/legal/CookiePolicy.tsx

import React from 'react';
import { View, Text, ScrollView, StyleSheet } from 'react-native';

const CookiePolicy = () => (
  <ScrollView style={styles.container}>
    <Text style={styles.header}>Cookie Policy</Text>
    <Text style={styles.body}>
      REA uses cookies to enhance your experience and deliver personalized content. This policy explains how we use cookies on www.rea.mobi.
    </Text>

    <Text style={styles.subheader}>1. What Are Cookies?</Text>
    <Text style={styles.body}>
      Cookies are small data files stored on your device when you visit our platform. They help us remember your preferences and improve your user experience.
    </Text>

    <Text style={styles.subheader}>2. Types of Cookies We Use</Text>
    <Text style={styles.body}>
      - **Essential Cookies**: Required for the platform to function properly.
      {"\n"}- **Performance Cookies**: Help us analyze how you use our platform.
      {"\n"}- **Personalization Cookies**: Store your preferences, like language settings.
    </Text>

    <Text style={styles.subheader}>3. Managing Cookies</Text>
    <Text style={styles.body}>
      You can control or disable cookies through your browser settings. Note that disabling cookies may affect your experience on REA.
    </Text>
  </ScrollView>
);

const styles = StyleSheet.create({
  container: { padding: 20 },
  header: { fontSize: 24, fontWeight: 'bold', marginBottom: 10 },
  subheader: { fontSize: 18, fontWeight: '600', marginTop: 15 },
  body: { fontSize: 14, marginTop: 5, lineHeight: 20 },
});

export default CookiePolicy;
